/**
 * A prepared first answer waiting for its Thread (SB-13, F37): a Thread about an item, started
 * on a Workflow whose first step asks a person, gets the text the preparation view held as
 * that step's answer, ready to send. The preparation owns it from Start until the person step
 * sends it; kept for this browser tab only, so a reload keeps it.
 */
const KEY_PREFIX = "dmw.threads.preparedAnswer.";

export function keepPreparedAnswer(threadId: string, text: string): void {
  try {
    window.sessionStorage.setItem(KEY_PREFIX + threadId, text);
  } catch {
    // Storage blocked: the person writes the answer themselves.
  }
}

export function readPreparedAnswer(threadId: string): string | null {
  try {
    return window.sessionStorage.getItem(KEY_PREFIX + threadId);
  } catch {
    return null;
  }
}

export function clearPreparedAnswer(threadId: string): void {
  try {
    window.sessionStorage.removeItem(KEY_PREFIX + threadId);
  } catch {
    // Nothing kept, nothing to clear.
  }
}
